<template>
  <div>
    <!-- <notifications group="qubit_error" title='Notification' clean="true" :max='max' :duration='duration' classes='vue-notification notifcation-error shadow-sm'/>
    <notifications group="qubit_message" title='notification' :max='max' :duration='duration' classes='vue-notification notifcation-success shadow p-3 mb-5'/>-->
    <notifications group="qubit_error" position="top right" :duration="duration" :max="max">
      <template slot="body" slot-scope="props">
        <div class="pgn-wrapper">
          <div class="pgn push-on-sidebar-open pgn-simple">
            <div class="alert alert-danger">
              <button type="button" class="close" data-dismiss="alert" @click="props.close">
                <span aria-hidden="true">×</span>
                <span class="sr-only">Close</span>
              </button>
              {{props.item.text}}
            </div>
          </div>
        </div>
      </template>
    </notifications>

    <notifications group="qubit_message" position="top right" :duration="duration" :max="max">
      <template slot="body" slot-scope="props">
        <div class="pgn-wrapper">
          <div class="pgn push-on-sidebar-open pgn-simple">
            <div class="alert alert-info">
              <button type="button" class="close" data-dismiss="alert" @click="props.close">
                <span aria-hidden="true">×</span>
                <span class="sr-only">Close</span>
              </button>
              {{props.item.text}}
            </div>
          </div>
        </div>
      </template>
    </notifications>
    <span v-if="isMobile">
        <MobileState />
    </span>
    <span v-else-if="isIE">
      <noie />
    </span>
    <span v-else-if="!doesSupportES5">
      <label>We do not support this browser, please upgrade.</label>
    </span>
    <div v-else>
      <lock-screen v-if="$store.state.idle && userData.username" @loggedIn="$store.state.idle  = false"/>
      <router-view :class="[($store.state.idle  && userData.username) ? 'hidden' : '']" />
      <!-- {{ idle }} -->
    </div>
  </div>
</template>
<style src="@/assets/themes/light.css" type="text/css">
</style>
<style type="text/css">
.br {
  border:solid 1px #000;
}

.clickable {
  cursor: pointer;
}

.tooltip {
  display: block !important;
  z-index: 100000000;
}

.dropdown {
  padding-left: 0 !important;
}

.iti-flag {
  margin-left: 0 !important;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.show-invalid {
  border: 2px solid #cd5c5c !important;
}

.breadcrumb li{
  font-size: 10.5px !important;
}

.show-invalid.focused {
  outline: 1px solid #cd5c5c !important;
}

.pgn-wrapper {
  right: 0;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.table td, .table th {
  vertical-align: middle !important;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.breadcrumb-item {
  height: 20px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

.select2-container {
  min-width: 150px !important;
}

</style>
<script>
import { ulid } from "ulid";
import LockScreen from "./components/Lockscreen";
import noie from "./components/noie";
import { mapState } from "vuex";
import MobileState from './components/MobileState';
// import git from 'git-rev-sync';

var lastNetworkMode;
// Internet Explorer 6-11
var isIE = /*@cc_on!@*/false || !!document.documentMode;

function isMobileDevice() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};

var pageMethods = {
  checkNetwork() {
    window.addEventListener("load", () => {
      let updateOnlineStatus = () => {
        if (navigator.onLine === false) {
          // clear all previous notifications
          this.$notify({
            group: "qubit_error",
            title: "Network",
            text:
              "You have lost access to the internet."
          });

          this.$notify({
            group: "qubit_message",
            clean: true
          });

          lastNetworkMode = false;
        } else {
          if (lastNetworkMode === false) {
            // clear all previous notifications
            this.$notify({
              group: "qubit_message",
              title: "Network",
              text: "Internet detected, enjoy the power of QuBit."
            });

            this.$notify({
              group: "qubit_error",
              clean: true
            });
          }
          lastNetworkMode = true;
        }
      };

      // setTimeout(updateOnlineStatus(), 2000);
      window.addEventListener("online", updateOnlineStatus);
      window.addEventListener("offline", updateOnlineStatus);
    });
  },
  onIdle () {
    alert("yoo");
  }
};

export default {
  name: "App",
  props: ["active"],
  created() {
    lastNetworkMode = undefined;
    localStorage.getItem("_$_RD$___E23ed")
      ? ""
      : localStorage.setItem("_$_RD$___E23ed", ulid());
    this.checkNetwork();
  },
  watch: {
    active: function() {
      if (this.active == 0 && this.userData.username) {
        localStorage.idle = true;
        this.$store.state.idle = true;
        window.eventBus.$emit("locked"); // Consumed in dashboard index
      }
    },
    "$store.state.idle": (newVal) => {
      if (newVal == false) {
        window.eventBus.$emit("unlocked"); // Consumed in dashboard index
      }
      else {
        localStorage.idle = true;
        newVal = true;
        window.eventBus.$emit("locked"); // Consumed in dashboard index
      }
    }
  },
  data() {
    return {
      duration: -10000,
      mobileDesk: false,
      isMobile: false,
      isIE,
      max: 1,
    };
  },
  mounted() {
    if(isMobileDevice()) {
      if (localStorage.mobileDesk) {
          this.isMobile = false;
      }
      else {
        this.isMobile = true;
      }
    }
    else {
      this.$store.state.idle = localStorage.idle ? localStorage.idle : false;
    }
    // alert(this.doesSupportES5)
  },
  methods: pageMethods,
  components: { LockScreen, noie, MobileState },
  computed: {
    ...mapState(["userData"]),
    doesSupportES5() {
      return 'Promise' in window;
    }
  }
};
</script>
